import React from 'react';

import {Dialog} from 'shells/dialog/dialog';
import {Body} from 'shells/typography/body';

import {getSingleSignOnCopy} from '../helpers';

import {SsoConfigureButtons} from './sso-configure-buttons';

type Props = {
    canSetupSso: boolean;
    isConfigured: boolean;
    onManageSso: () => void;
    onDisableSso: () => void;
    onSetupSso: () => void;
    canDisableSso: boolean;
    hasVerifiedDomain: boolean;
    organizationId: string | null | undefined;
    setIsFeatureGateModalOpen: (isOpen: boolean) => void;
};

export function SsoConfigure(props: Props) {
    const [isDisableSsoConfirmationOpen, setIsDisableSsoConfirmationOpen] =
        React.useState<boolean>(false);

    const disableRef = React.useRef<HTMLElement | null | undefined>(null);

    const handleDisableSso = () => {
        setIsDisableSsoConfirmationOpen(false);
        props.onDisableSso();
    };

    return (
        <div>
            <div className='flex'>
                <Body size='small' isBold={true}>
                    Configure your single sign-on
                </Body>
                <SsoConfigureButtons
                    canSetup={props.canSetupSso}
                    isConfigured={props.isConfigured}
                    setIsFeatureGateModalOpen={props.setIsFeatureGateModalOpen}
                    disableRef={disableRef}
                    setIsDisableSsoConfirmationOpen={setIsDisableSsoConfirmationOpen}
                    onManageSso={props.onManageSso}
                    onSetupSso={props.onSetupSso}
                    canDisableSso={props.canDisableSso}
                />
            </div>
            <div className='flex'>
                <Body size='small' color='medium'>
                    {getSingleSignOnCopy(
                        props.isConfigured,
                        props.hasVerifiedDomain,
                        props.organizationId
                    )}
                </Body>
            </div>
            {isDisableSsoConfirmationOpen && (
                <Dialog
                    anchor={disableRef.current}
                    question='Disabling this will reset your SSO configuration. If you want to enable, you wil have to start over.'
                    primaryText='Yes, disable'
                    primaryVariant='danger'
                    secondaryText='No, don’t disable'
                    secondaryVariant='secondary'
                    onPrimary={() => {
                        handleDisableSso();
                    }}
                    onSecondary={() => setIsDisableSsoConfirmationOpen(false)}
                    location='bottom'
                    customStyles={{
                        width: '240px',
                    }}
                />
            )}
        </div>
    );
}
